import { createLazyResolver } from 'owa-lazy-resolver';

export const lazyAppBarControlM365AppsQueryWeb = createLazyResolver(
    'APPBARCONTROL_M365APPS_QUERY_WEB',
    () => import(/* webpackChunkName: "AppBarControlQueryWeb" */ './appBarControlQueryWeb'),
    m => m.appBarControlM365AppsQueryWeb
);

export const lazyAppDefinitionQueryWeb = createLazyResolver(
    'APPBARCONTROL_APPDEFINITION_QUERY_WEB',
    () => import(/* webpackChunkName: "AppDefinitionQueryWeb" */ './appDefinitionQueryWeb'),
    m => m.appDefinitionQueryWeb
);
